<template class="full-height">
  <div class="member-container full-height">
    <el-dialog
      :top="dialogTopMargin"
      v-loading="listLoading"
      :visible.sync="dialogMemberFormVisible"
      :title="
        roleSettingObj.id ? `編輯${roleSettingObj.account}${roleSettingObj.name}帳號` : '新增帳號'
      "
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-alert
            :closable="false"
            title="密碼為使用不可逆的加密演算法，所以密碼無法查詢。只能設定新密碼。"
            type="warning"
            effect="dark"
          >
          </el-alert>
        </div>
        <el-form
          :rules="rules"
          size="mini"
          ref="memberForm"
          :model="roleSettingObj"
          :label-width="formLabelWidth"
        >
          <el-form-item :label="'旅行社代碼'">
            <el-select
              size="mini"
              v-model="roleSettingObj.agencyCode"
              filterable
              clearable
              placeholder="請選擇"
            >
              <el-option
                v-for="item in agencyList"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              />
            </el-select>
          </el-form-item>

          <el-form-item :label="'帳號'" prop="account">
            <el-input v-model="roleSettingObj.account"></el-input>
          </el-form-item>

          <el-form-item :label="'姓名'" prop="name">
            <el-input v-model="roleSettingObj.name"></el-input>
          </el-form-item>

          <el-form-item :label="'Mail'" prop="mail">
            <el-input v-model="roleSettingObj.mail"></el-input>
          </el-form-item>

          <el-form-item :label="'電話'" prop="mobile">
            <el-input v-model="roleSettingObj.mobile"></el-input>
          </el-form-item>

          <el-form-item :label="'生日'">
            <el-date-picker
              style="width: 100%"
              v-model="roleSettingObj.birthday"
              type="date"
              placeholder="請選擇領隊生日"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="狀態">
            <el-radio-group v-model="roleSettingObj.status">
              <el-radio :label="0">停用</el-radio>
              <el-radio :label="1">啟用</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="'密碼'" prop="pwd">
            <el-button
              style="margin-bottom: 5px"
              v-if="roleSettingObj.id"
              :type="showPwdInupt ? 'primary' : 'success'"
              size="mini"
              @click="showPwdInuptHandler"
              >{{ showPwdInupt ? '取消' : '更改密碼' }}</el-button
            >
            <el-input
              v-if="!roleSettingObj.id || showPwdInupt"
              v-model="roleSettingObj.pwd"
              show-password
            ></el-input>
            <i style="color: #ccc; font-size: 12px; margin: 5px"
              >密碼原則：密碼必須包含英文，數字及長度介於6-16之間。</i
            >
          </el-form-item>
        </el-form>
        <div></div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData('memberForm')">確定</el-button>
        <el-button type="danger" @click="dialogMemberFormVisible = !dialogMemberFormVisible"
          >取消</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      v-if="rolesList.length > 0"
      :visible.sync="dialogFormVisible"
      :title="roleSettingObj.account + roleSettingObj.name + '-' + '角色設定'"
    >
      <el-table :data="rolesList" border fit highlight-current-row style="width: 100%">
        <el-table-column :label="'選取'">
          <template slot-scope="scope">
            <el-checkbox v-model="rolesSelected" :label="scope.row.roleCode"> 選取 </el-checkbox>
          </template>
        </el-table-column>

        <el-table-column :label="'角色代碼'">
          <template slot-scope="scope"> {{ scope.row.roleCode }} </template>
        </el-table-column>

        <el-table-column :label="'角色名稱'">
          <template slot-scope="scope">
            {{ scope.row.roleName }}
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRoles">確定</el-button>
        <el-button type="danger" @click="dialogFormVisible = !dialogFormVisible">取消</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0" class="full-height">
      <div style="padding-bottom: 0">
        <el-alert
          :closable="false"
          type="success"
          effect="dark"
          style="border: 2px solid #ccc; margin: 5px"
        >
          <template slot="title">
            <div class="iconSize">需要注意的事项:</div>
            <div class="iconSize">
              1、一般查詢：完整名稱查詢，需輸入完整帳號或姓名才會查詢得到結果。英文會區分大小寫
            </div>
            <div class="iconSize">
              2、關鍵字查詢：可使用關鍵字查詢，例：搜尋姓氏為王的名稱，輸入：王%。搜尋名字為小明的名稱，輸入：%小明。英文不用區分大小寫
            </div>
          </template>
        </el-alert>

        <el-form :inline="true" @submit.prevent.native="handleFilter">
          <el-form-item label="搜尋">
            <el-input
              size="mini"
              v-model="listQuery.qry"
              placeholder="輸入查詢"
              v-on:keydown.enter.native="handleFilter"
            />
          </el-form-item>

          <el-form-item label="狀態">
            <el-select v-model="listQuery.status" placeholder="請選擇狀態" clearable>
              <el-option
                v-for="item in [
                  { key: 0, val: '停用' },
                  { key: 1, val: '啟用' },
                ]"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              class="filter-item"
              type="primary"
              icon="el-icon-search"
              @click="handleFilter"
            >
              搜尋
            </el-button>

            <el-button type="success" size="mini" @click="addData" icon="el-icon-plus"
              >建立</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="listLoading"
              type="success"
              icon="el-icon-refresh-left"
              circle
              @click="refresh"
            ></el-button>
          </el-form-item>

          <el-form-item>
            <el-radio-group
              @change="handleFilter"
              v-model="listQuery.listType"
              style="border: 1px solid #ccc; user-select: auto; padding: 10px"
            >
              <el-radio :label="1">所有帳號</el-radio>
              <el-radio :label="2">TC網帳號</el-radio>
              <el-radio :label="3">App旅客</el-radio>
              <el-radio :label="4">App領隊</el-radio>
              <el-radio :label="5">旅行社帳號</el-radio>
              <el-radio :label="6">ITA行政</el-radio>
              <el-radio :label="7">ITA管理員</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div style="position: relative; height: 80%">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
          @sort-change="sortChange"
        >
          <el-table-column :label="'ID'" prop="id" sortable="custom" align="center" width="80">
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="'帳號'"
            prop="account"
            sortable="custom"
            align="left"
            width="180"
          >
            <template slot-scope="{ row }">
              <span>{{ row.account }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column
            v-if="checkPermission(['ITA-DEV'])"
            :label="'auth'"
            prop="name"
            sortable="custom"
            align="center"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.name }}</span>
            </template>
          </el-table-column> -->

          <el-table-column :label="'姓名'" prop="name" sortable="custom" align="left" width="180">
            <template slot-scope="{ row }">
              <span>{{ row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="狀態" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 0 ? 'danger' : 'success'">{{
                scope.row.status == 0 ? '停用' : '啟用'
              }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="warning"
                icon="el-icon-edit"
                @click="editData(scope.row)"
              >
                編輯資料
              </el-button>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="primary"
                icon="el-icon-key"
                @click="showSelfRoles(scope.row)"
              >
                角色設定
              </el-button>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            :label="'刪除'"
            width="200"
            v-if="checkPermission(['ITA-DEV'])"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="danger"
                icon="el-icon-key"
                @click="deleteMember(scope.row)"
              >
                刪除
              </el-button>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            :label="'查詢密碼'"
            width="200"
            v-if="checkPermission(['ITA-DEV'])"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="info"
                icon="el-icon-view"
                @click="getMemberPwd(scope.row)"
              >
                查詢密碼
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        style="padding-top: 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { getMembers, getRoles, saveRoles, saveData, deleteMember } from '@/api/member'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
import { getAgencyOptions } from '@/api/travel'
import { getMemberPwd } from '@/api/user'

import checkPermission from '@/utils/permission' // 权限判断函数
var defaultFormData = {
  account: null,
  agency: null,
  agencyCode: null,
  birthday: '1990-01-01',
  id: null,
  mobile: null,
  name: null,
  roles: [],
  status: 1,
}
export default {
  name: 'Member',
  components: { Pagination },
  directives: { waves },
  filters: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (!checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN'])) {
        let re = new RegExp(/^(?=.*\d)(?=.*[a-z]).{6,16}$/)
        if (!this.roleSettingObj.id && (!value || value === '')) {
          callback(new Error('請輸入密碼'))
        } else if (value.length > 0 && !re.test(value) && process.env.NODE_ENV != 'development') {
          callback(new Error('密碼請依照密碼原則建立!'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    var validateMobile = (rule, value, callback) => {
      if (!checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN'])) {
        let re = new RegExp(/^09[0-9]{8}$/)
        if (value && value.length > 0 && !re.test(value)) {
          callback(new Error('手機號碼格式為:0911222333'))
        } else {
          callback()
        }
      } else {
        callback()
      }

      // if (!value || value === "") {
      //   callback(new Error("請輸入手機號碼"));
      // } else if (value.length > 0 && !re.test(value)) {
      //   callback(new Error("手機號碼格式為:0911222333"));
      // } else {
      //   callback();
      // }
    }
    var validateMail = (rule, value, callback) => {
      let re = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      if (value && value.length > 0 && !re.test(value)) {
        callback(new Error('mail格式不正確'))
      } else {
        callback()
      }

      // if (!value || value === "") {
      //   callback(new Error("請輸入手機號碼"));
      // } else if (value.length > 0 && !re.test(value)) {
      //   callback(new Error("手機號碼格式為:0911222333"));
      // } else {
      //   callback();
      // }
    }
    return {
      rules: {
        pwd: [{ validator: validatePass, trigger: 'blur' }],
        account: [{ required: true, message: '請輸入帳號', trigger: 'blur' }],
        name: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        mobile: [{ validator: validateMobile, trigger: 'blur' }],
        mail: [{ validator: validateMail, trigger: 'blur' }],
      },
      showPwdInupt: false,
      agencyList: [],
      funcName: '帳號管理',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      dialogMemberFormVisible: false,
      rolesSelected: [],
      roleSettingObj: {},
      rolesList: [],
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        listType: 1,
        page: 1,
        limit: 30,
        importance: undefined,
        title: undefined,
        type: undefined,
        status: 1,
        sort: '-cUpdateDT',
      },
      dialogFormVisible: false,
    }
  },
  async created() {
    this.getAgencyOptions()
    this.getRoles()
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        listType: 1,
        page: 1,
        status: 1,
        limit: 30,
        status: undefined,
        importance: undefined,
        title: undefined,
        type: undefined,
        sort: '-cUpdateDT',
      }
      await this.getList()
    },
    async getMemberPwd(row) {
      let resp = await getMemberPwd({ userID: row.id })
      console.log(resp)
      if (resp.success && resp.data) {
        alert(resp.data)
      } else {
        alert('查無密碼')
      }
    },
    async deleteMember(row) {
      let vm = this
      if (confirm(`確定刪除【${row.name}】使用者資訊?一但刪除連同旅客關聯檔也會一併刪除。\r\n`)) {
        vm.loadingHanlder(true)
        let resp = await deleteMember({ id: row.id })
        if (resp.success) {
          await vm.getList()
          vm.$message({
            message: '操作成功',
            type: 'success',
          })
        }
        vm.loadingHanlder(false)
      }
    },
    showPwdInuptHandler() {
      this.showPwdInupt = !this.showPwdInupt
    },
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading != action) {
        vm.listLoading = action
      }
    },
    checkPermission,
    async getAgencyOptions() {
      // this.loadingHanlder(true);
      await getAgencyOptions().then(response => {
        this.agencyList = response.data
        // this.loadingHanlder(false);
      })
    },
    saveRoles() {
      const vm = this
      const payload = {
        account: this.roleSettingObj.account,
        roles: this.rolesSelected,
      }

      this.$confirm(
        `確定儲存【${this.roleSettingObj.account}-${this.roleSettingObj.name}】的角色設定?`,
        '權限設定',
        {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'confirmTitle',
        }
      )
        .then(async () => {
          this.loadingHanlder(true)

          saveRoles(payload)
            .then(response => {
              vm.dialogFormVisible = !vm.dialogFormVisible

              this.loadingHanlder(false)

              if (response.success) {
                const u = vm.list.filter(f => {
                  return f.account == vm.roleSettingObj.account
                })[0]
                u.roles.splice(0, u.roles.length)

                vm.rolesSelected.forEach(f => {
                  u.roles.push(f)
                })

                const userInfo = `${vm.roleSettingObj.account}-${vm.roleSettingObj.name}權限已設定`
                this.$notify({
                  title: 'Success',
                  dangerouslyUseHTMLString: true,
                  message: `
            <div>User：${userInfo}</div>
          `,
                  type: 'success',
                })
              }
            })
            .catch(error => {
              // 處理捕捉到的錯誤
              console.error('Error:', error)
              vm.loadingHanlder(false)
              this.$notify({
                title: 'Error',
                message: `${error.data.message}`,
                type: 'error',
              })
            })
        })
        .catch(err => {
          console.error(err)
        })
    },
    addData(row) {
      let vm = this
      vm.dialogMemberFormVisible = true
      vm.roleSettingObj = JSON.parse(JSON.stringify(defaultFormData))
    },
    editData(row) {
      let vm = this
      vm.dialogMemberFormVisible = true
      console.log(row)
      vm.roleSettingObj = row
    },
    async saveData(formName) {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.loadingHanlder(true)
          try {
            let resp = await saveData(vm.roleSettingObj)
            vm.getList()
            vm.dialogMemberFormVisible = false
            this.loadingHanlder(false)
            this.$message({
              message: '操作成功',
              type: 'success',
            })
          } catch (error) {
            console.log = error.data.message
          } finally {
            this.loadingHanlder(false)
          }
        } else {
          return false
        }
      })
    },
    showSelfRoles(user) {
      const vm = this
      vm.dialogFormVisible = !vm.dialogFormVisible
      vm.roleSettingObj = user
      // empty array
      vm.rolesSelected.splice(0, vm.rolesSelected.length)
      vm.rolesList.forEach(f => {
        const hasRole = user.roles.some(role => role == f.roleCode)
        if (hasRole) {
          vm.rolesSelected.push(f.roleCode)
        }
      })
    },
    getRoles() {
      // this.loadingHanlder(true);
      getRoles().then(response => {
        if (checkPermission(['ITA-ADM-STAFF'])) {
          this.rolesList = response.data.filter(f => {
            return f.roleCode == 'ITA-NORMAL' || f.roleCode == 'ITA-TRAVEL-AGENCY'
          })
        } else {
          this.rolesList = response.data
        }

        // this.loadingHanlder(false);
      })
    },
    refreshSelectedTag(path) {
      this.$store.dispatch('tagsView/delCachedViewByName', 'ProductSalesanAlysis').then(() => {
        this.$nextTick(() => {
          this.$router.replace({
            path: path.replace('#', ''),
          })
        })
      })
    },
    async getList() {
      this.loadingHanlder(true)
      var res = await getMembers(this.listQuery)
      if (checkPermission(['ITA-ADM-STAFF'])) {
        this.list = res.data.data.filter(f => {
          return f.roles.some(s => s == 'ITA-TRAVEL-AGENCY')
        })
      } else {
        this.list = res.data.data
      }

      this.total = res.data.total
      this.loadingHanlder(false)
    },
    handleFilter(e) {
      this.listQuery.page = 1
      this.getList()
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.status = status
    },
    sortChange(data) {
      const { prop, order } = data
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}

.iconSize {
  font-size: 14px;
}
</style>
